import React, { memo } from "react";
import { useLabels } from "../../../hooks/useLabels";
import { useUserEvents } from "../../../hooks/useUserEvents";
import { Button } from "../../button";
import { EmptyState } from "../../empty-placeholder/empty-state";
import { labels } from "./labels";
import { useUserDateDialogActions, useUserDateDialogState } from "./use-user-date-dialog-state";
import { UserDateItem } from "./user-date-item";

import "./user-date-list.css";

export const UserDateList = memo(() => {
	const [[showAllText, hideAllText, emptyTitle, emptyText]] = useLabels([
		labels.showAll,
		labels.hideAll,
		labels.noEventsTitle,
		labels.noEventsText,
	]);

	const { isPending: isAccountUserDatesLoading } = useUserEvents();

	const { sortedUserDates, userDates } = useUserDateDialogState();

	const { toggleAll } = useUserDateDialogActions();

	return (
		<div className="user-date-list">
			{!!userDates.size && (
				<div className="user-date-list__filter">
					{/* Use transparent button instead of variant: 'link'? */}
					<Button
						variant="link"
						onClick={() => toggleAll(true)}
						className="user-date-list__filter-button"
					>
						{showAllText}
					</Button>
					<Button
						variant="link"
						onClick={() => toggleAll(false)}
						className="user-date-list__filter-button"
					>
						{hideAllText}
					</Button>
				</div>
			)}

			{sortedUserDates.map(({ id, dateCode, value }) => (
				<UserDateItem key={id} dateCode={dateCode} id={id} value={value} />
			))}
			{!(!!userDates.size || isAccountUserDatesLoading) && (
				<EmptyState
					title={emptyTitle}
					subtitle={emptyText}
					className="user-date-list__placeholder"
					iconName="calendar"
				/>
			)}
		</div>
	);
});
UserDateList.displayName = "UserDateList";
